<!-- Hero proof line -->
<div class="strip" *ngIf="mode === 'strip' && rows.length">
  <div class="wrap strip-inner">
    <span class="strip-kicker">{{ theme.eyebrow }}</span>
    <span class="strip-text"><span class="strip-plate">{{ rows[0].plate }}</span> from {{ gbp(rows[0].buy) }} at DVLA, sold for <strong>{{ gbp(first(rows[0]).price) }}</strong> in {{ first(rows[0]).label.slice(-4) }}.</span>
    <a class="strip-link" href="#resold" (click)="toSection($event)">{{ rows.length > 1 ? 'See the top ' + year + 's' : 'See the ' + year }} &rarr;</a>
  </div>
</div>

<section class="section" id="resold" *ngIf="mode === 'section' && rows.length"><div class="wrap">
  <div class="sec-head">
    <span class="eyebrow">{{ theme.eyebrow }}</span>
    <h2>{{ theme.title(year, rows.length) }}</h2>
    <p>{{ theme.intro(year, rows.length) }}</p>
  </div>

  <div class="layout">
    <table class="rows">
      <thead><tr><th>Plate</th><th>Bought</th><th>Sold</th><th class="num">ROI</th><th class="num">Annualised</th></tr></thead>
      <tbody>
        <tr *ngFor="let r of rows; let i = index" [class.sel]="i === sel" (mouseenter)="select(i)" (click)="select(i)">
          <td><pla-plate [rawPlate]="r.plate" [showPrice]="false" [customClass]="'flat shaded'" [xSmallPlate]="true"
                         [openModal]="false" [clickThrough]="false" [noMargin]="true"></pla-plate></td>
          <td>from {{ gbp(r.buy) }}<span class="sub">{{ onSale(r) }}</span></td>
          <td>{{ gbp(first(r).price) }}<span class="sub"><span class="d-mob">from {{ gbp(r.buy) }} &middot; </span>{{ first(r).label }}<ng-container *ngIf="r.sales.length > 1"><span class="d-desk"> &middot; resold {{ r.sales.length - 1 }}x since</span></ng-container></span></td>
          <td class="num pos">{{ roi(r) }}<span class="sub d-desk">{{ gain(r) }} gain</span><span class="sub d-mob">{{ annual(r) || ('in ' + held(r)) }}</span></td>
          <td class="num">{{ annual(r) || ('in ' + held(r)) }}<span class="sub">{{ annual(r) ? 'over ' + held(r) : '' }}</span></td>
        </tr>
      </tbody>
    </table>

    <figure class="chart">
      <figcaption>
        <span class="key"><i class="k-plate"></i>{{ rows[sel].plate }}</span>
        <ng-container *ngIf="hasIndex">
          <span class="key"><i class="k-index"></i>Current market index</span>
          <span class="key"><i class="k-band"></i>95% range</span>
        </ng-container>
      </figcaption>
      <svg [attr.viewBox]="'0 0 ' + W + ' ' + H" role="img"
           [attr.aria-label]="rows[sel].plate + ' bought from DVLA and resold, against the current market index from the same starting price'">
        <rect [attr.x]="P.l" [attr.y]="P.t" [attr.width]="W - P.l - P.r" [attr.height]="H - P.t - P.b" class="plot-bg"/>
        <g *ngFor="let t of yTicks">
          <line [attr.x1]="P.l" [attr.x2]="W - P.r" [attr.y1]="t.y" [attr.y2]="t.y" class="grid"/>
          <text [attr.x]="P.l - 8" [attr.y]="t.y + 4" text-anchor="end" class="tick">{{ t.label }}</text>
        </g>
        <text *ngFor="let t of xTicks" [attr.x]="t.x" [attr.y]="H - 8" text-anchor="middle" class="tick">{{ t.label }}</text>
        <g *ngIf="hasIndex">
          <path [attr.d]="band" class="band"/>
          <path [attr.d]="indexLine" class="index"/>
          <path [attr.d]="indexDash" class="index index--dash"/>
        </g>
        <line [attr.x1]="buyX" [attr.x2]="buyX" [attr.y1]="P.t" [attr.y2]="H - P.b" class="buy-line"/>
        <text [attr.x]="buyX + 6" [attr.y]="P.t + 10" class="buy-label">Bought from DVLA &middot; {{ gbp(rows[sel].buy) }}</text>
        <path [attr.d]="plateLine" class="plate"/>
        <circle [attr.cx]="buyX" [attr.cy]="buyY" r="5" class="dot dot--buy"/>
        <g *ngFor="let d of dots">
          <circle [attr.cx]="d.x" [attr.cy]="d.y" [attr.r]="d.label ? 5 : 3.5" class="dot"/>
          <text [attr.x]="d.x - 9" [attr.y]="d.y + 4" text-anchor="end" class="dot-label">{{ d.label }}</text>
        </g>
      </svg>
      <p class="chart-note">{{ gbp(rows[sel].buy) }} became {{ gbp(first(rows[sel]).price) }}.<ng-container *ngIf="hasIndex"> The same {{ gbp(rows[sel].buy) }} following the current market index would be about {{ gbp(indexEnd) }}.</ng-container><ng-container *ngIf="!hasIndex"> The current market index starts in 2010, after this plate was bought.</ng-container></p>
    </figure>
  </div>

  <p class="foot">DVLA prices include VAT and the &pound;80 assignment fee; resale figures don't deduct selling costs. Past results don't guarantee future value. General information, not personal financial advice.</p>
</div></section>
